import * as styles from "./map-context-menu.module.scss";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import mapboxgl from "mapbox-gl";
import { StyleableIcon } from "../../helper/icon-helper";
import * as globals from "../../styles/global.icss.scss";

export interface MapContextMenuItem {
	icon: StyleableIcon;
	label: string;
	onClick: () => void;
}

export default function MapContextMenu(props: {
	map: mapboxgl.Map;
	lngLat: mapboxgl.LngLat;
	items: MapContextMenuItem[];
}) {
	const { map, lngLat } = props;
	const [element] = useState(() => document.createElement("div"));

	useEffect(() => {
		const marker = new mapboxgl.Marker(element)
			.setLngLat(lngLat)
			.addTo(map);

		return () => {
			marker.remove();
		};
	}, [map, lngLat, element]);

	return createPortal(
		<div className={styles.list}>
			{props.items.map((item) => (
				<button
					key={item.label}
					className={styles.button}
					onClick={item.onClick}
				>
					{item.icon(16, globals.textPrimary)}
					<span>{item.label}</span>
				</button>
			))}
		</div>,
		element,
	);
}
